"use strict";import{Divider as e}from"./src/Divider.js";import{defineElement as i}from"@spectrum-web-components/base/src/define-element.js";i("sp-divider",e);
//# sourceMappingURL=sp-divider.js.map
